function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M54.2,75.1s0,0-.1,0c0,0-.2,0-.2,0-11.8-.1-20.2-7.6-28.3-14.7-3-2.6-5.7-5.1-8.7-7.2-.8-.6-1.1-1.6-.8-2.6.4-.9,1.3-1.5,2.3-1.4,4.7.6,6.5-.7,8.5-2.2.5-.4,1-.7,1.6-1.1,4.8-3.9,6.2-4.6,8.3-5.8.6-.3,1.3-.7,2.1-1.2.1,0,.3-.1.4-.2,6.7-2.2,12.3,1.2,15.3,3.9,2.9-2.8,8.5-6.2,15.3-3.9.1,0,.3.1.4.2.8.5,1.5.8,2.1,1.2,2.1,1.2,3.5,1.9,8.3,5.8.6.3,1.1.7,1.6,1.1,2.1,1.5,3.8,2.7,8.5,2.2,1-.1,1.9.5,2.3,1.4.4.9,0,2-.8,2.6-3,2.1-5.7,4.6-8.7,7.2-8.1,7.2-16.4,14.6-28.3,14.7,0,0-.2,0-.2,0-.1,0-.3,0-.4,0h-.1s-.2,0-.2,0c0,0-.2,0-.3,0ZM54.7,70.7s.1,0,.2,0c0,0,.2,0,.2,0,10.3,0,17.8-6.6,25.6-13.6,1.4-1.3,2.9-2.5,4.3-3.8-2.4-.6-4-1.7-5.4-2.7-.5-.4-.9-.7-1.4-1,0,0-.2-.1-.2-.2-4.6-3.7-5.8-4.4-7.8-5.4-.6-.3-1.2-.7-2-1.1-6-1.9-10.9,3.1-11.9,4.4-.4.6-1.1,1-1.8,1h0c-.7,0-1.4-.4-1.8-1-.9-1.3-5.9-6.2-11.9-4.4-.8.5-1.4.8-2,1.1-2,1.1-3.2,1.7-7.8,5.4,0,0-.2.1-.2.2-.5.3-.9.6-1.4,1-1.4,1-3,2.1-5.4,2.7,1.5,1.2,2.9,2.5,4.3,3.8,7.9,7,15.3,13.6,25.7,13.6,0,0,.2,0,.2,0,0,0,.2,0,.3,0h0Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M54.9,60.4h-.1c-.6,0-1.2-.3-1.5-.8-2.7-2-7.5-4.7-13.2-4-8.9,1.7-15.9-.3-19.2-1.2l-.7-.2c-1-.3-1.6-1.3-1.3-2.3.3-1,1.3-1.6,2.3-1.3l.8.2c3.3,1,9.5,2.7,17.5,1.1,0,0,0,0,.1,0,6.5-.9,12.1,1.9,15.4,4.2,3.3-2.3,8.8-5.1,15.4-4.2,0,0,0,0,.1,0,8,1.6,14.2-.2,17.5-1.1l.8-.2c1-.3,2,.3,2.3,1.3s-.3,2-1.3,2.3l-.7.2c-3.4,1-10.3,3-19.2,1.2-5.7-.8-10.5,2-13.2,4-.3.5-.9.8-1.5.8Z"
});

var SvgIcoSimulationCategoryLips = function SvgIcoSimulationCategoryLips(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 110 110",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoSimulationCategoryLips, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_simulation_category_lips.90bf5e13.svg";
export { ForwardRef as ReactComponent };